<template>
  <div class="user-list">
    <el-tabs v-model="searchParam.subscribe_state" type="card" @tab-click="getList">
      <el-tab-pane label="全部" name=" "></el-tab-pane>
      <el-tab-pane label="未审核" name="0"></el-tab-pane>
      <el-tab-pane label="已同意" name="1"></el-tab-pane>
      <el-tab-pane label="已拒绝" name="2"></el-tab-pane>
    </el-tabs>
    <div class="search-bar">
      <el-input
        v-model="searchParam.keyword_search"
        placeholder="输入要搜索的内容"
        clearable
        @clear="getList"
      ></el-input>
      <el-date-picker
        v-model="datas"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        @change="changeTime"
      >
      </el-date-picker>
      <el-button type="primary" @click="getList('clear')">查询</el-button>
    </div>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="id" label="id" fixed="left" width="120px"> </el-table-column>
        <el-table-column prop="user_name" label="用户昵称" width="120px"> </el-table-column>

        <el-table-column prop="user_mobile" label="手机号码" width="120px"> </el-table-column>
        <el-table-column prop="course_title" label="课程名称" width="120px"> </el-table-column>
        <el-table-column prop="section_title" label="章节名称" width="120px"> </el-table-column>

        <el-table-column prop="sign_date" label="补签时间"> </el-table-column>
        <el-table-column prop="create_time" label="申请时间"> </el-table-column>
        <el-table-column prop="subscribe_state" label="状态">
          <template slot-scope="scope">
            {{ ["待同意", "已同意", "不同意"][scope.row.subscribe_state] }}
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button v-if="scope.row.subscribe_state == 0" class="mid-blue" @click="editMskeup(scope.row, 1)"
              >同意</el-button
            >

            <el-button v-if="scope.row.subscribe_state == 0" class="mid-red" @click="noagree(scope.row)"
              >拒绝</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { markupList, editMskeup } from "@/api/edu.js";
import { getTeacherList } from "@/api/teacher.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  data() {
    return {
      datas: [],
      loading: false,
      teacherList: [],
      searchParam: {
        keyword_search: "",
        subscribe_state: " ",
        start_time: "",
        end_time: "",
      },
      tableData: [],
    };
  },
  mounted() {
    this.getList();
    this.getTeacher("");
  },
  methods: {
    changeTime(val) {
      if (val) {
        this.searchParam = {
          ...this.searchParam,
          start_time: val[0],
          end_time: val[1],
        };
      } else {
        this.searchParam = {
          ...this.searchParam,
          start_time: "",
          end_time: "",
        };
        this.getList();
      }
      console.log(val);
    },
    getTeacher(keyword_search) {
      getTeacherList({ keyword_search }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/course-add",
        query: row,
      });
    },

    setTop(row) {},
    xiajia(row) {},
    agree() {},
    editMskeup(row, type) {
      editMskeup({ subscribe_state: type }, row.id).then((res) => {
        if (res == true) {
          this.$message.success("成功");
          this.getList();
        }
      });
    },
    noagree(row) {
      this.$confirm("确定要拒绝该申请吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.editMskeup(row, 2);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList(type) {
      if (type == "clear") {
        this.page_index = 1;
      }
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      this.loading = true;
      const res = await markupList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
